import React from 'react'
import { RATES_TABS } from 'src/applications/rates/Rates'
import { i18n } from 'src/config'
import { appI } from '../redux/slices/DesktopSlice/DesktopSlice.types'

const Rates = React.lazy(
  async () => await import('src/applications/rates/Rates')
)

const Users = React.lazy(
  async () => await import('src/applications/users/UserRouter')
)

export const Applications: {
  USERS: appI
  // ROLES: appI
  RATES: appI
  COUPONS: appI
} = {
  USERS: {
    allowOpen: true,
    icon: '/assets/app_icons/usuarios.svg',
    id: 'A0B922F9BE2A47DF9A884D87DB59B514',
    name: i18n.t('applicationsTitles.users'),
    show: true,
    app: 'USERS',
    isNew: true
  },
  // ROLES: {
  //   allowOpen: true,
  //   icon: 'https://pruebas2.availroom.com/sialdPMS/ext/resources/images/icons/role.png',
  //   id: 'newRolesAppId',
  //   name: 'Roles',
  //   show: true,
  //   app: 'ROLES'
  // },
  RATES: {
    allowOpen: true,
    icon: '/assets/app_icons/tarifas.svg',
    id: 'CD5B4B7E65A246DB9697AA673AD8175F',
    name: i18n.t('applicationsTitles.rates'),
    show: true,
    app: 'RATES',
    isNew: true
  },
  COUPONS: {
    allowOpen: true,
    icon: 'assets/app_icons/cupones.svg',
    id: 'BA04BC75CD2D41D09D4959DBD221CD62',
    name: i18n.t('applicationsTitles.coupons'),
    show: true,
    app: 'COUPONS',
    isNew: true
  }
}

export const ApplicationViews: {
  [key in keyof typeof Applications]: JSX.Element
} = {
  COUPONS: <Rates defaultTab={RATES_TABS.COUPONS} />,
  RATES: <Rates />,
  USERS: <Users />
}
